(function() {
    const forms = document.querySelectorAll('form[data-confirm-submit]');
    const links = document.querySelectorAll('a[data-confirm-submit]');

    const confirmationModal = $('#form-confirmation-modal');

    if(!confirmationModal || (!forms.length && !links.length)) return;

    confirmationModal.on('hide.bs.modal', function() {
        clearEventListeners();
    });

    Array.from(forms).forEach(form => {
        form.addEventListener('submit', event => {
            event.preventDefault();

            openConfirmationModalForForm(form);
        });
    });

    Array.from(links).forEach(link => {
        link.addEventListener('click', event => {
            event.preventDefault();

            openConfirmationModalForLink(link);
        })
    })

    const openConfirmationModalForLink = link => {
        confirmationModal.modal('show');

        const button = document.querySelector('#form-confirmation-modal-submit');
        button.addEventListener('click', () => window.location.href = link.href);
    }

    const openConfirmationModalForForm = targetForm => {
        confirmationModal.modal('show');

        const button = document.querySelector('#form-confirmation-modal-submit');
        button.addEventListener('click', () => confirmForm(targetForm));
    }

    const clearEventListeners = () => {
        const button = document.querySelector('#form-confirmation-modal-submit');
        const newButton = button.cloneNode(true);
        button.parentNode.replaceChild(newButton, button);
    }

    const confirmForm = form => {
        form.submit();
    }
})()
